import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MenuButtons } from './MenuButtons';
import { MenuItem } from './MenuItem';
import { Wrap } from './Wrap';
import { UserService } from "../services/user/user.service";
import { FormsModule } from "@angular/forms";
import { environment } from "../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

@Component({
  selector: 'Menu',
  imports: [FormsModule, MenuButtons, MenuItem, Wrap],
  template: `
    <Wrap
        [class]="
        'flex !max-w-[1600px] min-h-[82.5px] justify-between items-center py-4 z-40 relative'
      "
    >
      <div class="flex flex-col items-center w-full p-5 pt-20 absolute left-0 top-0 z-30
          {{
          menuOpen
            ? 'opacity-100 transition-opacity duration-200'
            : 'opacity-0 pointer-events-none'
        }}
          lg:flex-row lg:w-auto lg:p-0 lg:relative lg:text-base
          lg:pointer-events-auto lg:opacity-100
          {{ loggedIn ? 'lg:ml-auto lg:mr-4' : '' }}
        ">
        @for (item of menuItems; track item.label) {
          <MenuItem [item]="item"></MenuItem>
        }

        <MenuButtons [menuOpen]="menuOpen" [class]="'flex lg:hidden mt-10'"></MenuButtons>
      </div>

      <div
        class="
        bg-purple-600 h-screen w-screen fixed top-0 left-0 z-20
        lg:pointer-events-none lg:opacity-0
        {{
          menuOpen
            ? 'opacity-100 transition-opacity duration-200'
            : 'opacity-0 pointer-events-none'
        }}
        "
      ></div>

      <MenuButtons [menuOpen]="menuOpen" [class]="'hidden md:flex mr-4 lg:mr-0'"></MenuButtons>

      <!-- hamburger menu -->
      <div
        class="
            lg:hidden w-12 h-12 center cursor-pointer -mr-2 md:-mr-4 z-40
          "
        (click)="toggleMenu()"
      >
        <div
          class="
          h-0.5 w-5 bg-white absolute transition-transform duration-100
          {{ menuOpen ? 'rotate-45' : '-translate-y-[7px]' }}
          "
        ></div>
        <div
          class="
          h-0.5 w-5 bg-white absolute transition-transform duration-100
          {{ menuOpen ? 'scale-x-0' : '' }}
         "
        ></div>
        <div
          class="
          h-0.5 w-5 bg-white absolute transition-transform duration-100
          {{ menuOpen ? '-rotate-45' : 'translate-y-[7px]' }}
          "
        ></div>
      </div>
    </Wrap>
  `,
})
export class Menu implements OnInit, AfterViewInit {
  menuItems: {
    href: string;
    label: string;
    icon?: string;
    children?: { label: string; href: string }[];
  }[];

  env = environment.env;

  menuOpen = false;
  loggedIn: boolean;

  constructor(private userService: UserService,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.loggedIn = this.userService.getUser()?.loggedIn;
  }

  async ngAfterViewInit() {
    this.loadMenuItems(); // no need to await this
    this.translate.onLangChange.subscribe(this.loadMenuItems.bind(this));
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  private async loadMenuItems() {
    if (this.loggedIn) {
      this.menuItems = [
        {
          label: await firstValueFrom(this.translate.get("HEADER_MENU_ITEM_DASHBOARD")),
          href: await firstValueFrom(this.translate.get("HEADER_MENU_ITEM_DASHBOARD_URL")),
          icon: 'dashboard',
        },
        {
          label: await firstValueFrom(this.translate.get("HEADER_MENU_ITEM_SETTINGS")),
          href: await firstValueFrom(this.translate.get("HEADER_MENU_ITEM_SETTINGS_URL")),
          icon: 'settings',
        }
      ];
    } else {
      this.menuItems = [];
    }
  }
}
